import { render, staticRenderFns } from "./ModalNaslov.vue?vue&type=template&id=5f72de87&scoped=true&"
import script from "./ModalNaslov.vue?vue&type=script&lang=js&"
export * from "./ModalNaslov.vue?vue&type=script&lang=js&"
import style0 from "./ModalNaslov.vue?vue&type=style&index=0&id=5f72de87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72de87",
  null
  
)

export default component.exports